// import '@/plugins/vue-composition-api'
// import './styles/styles.scss'
import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

Vue.use(Toast, {
  position: 'top'
});

Vue.use({
  install(Vue) {
    Vue.prototype.$currency = (value) => {
      if (value === null) return ''
      if (value === undefined) return ''
      if (value === '') return ''
      if (isNaN(value)) return value
      if (value === 0) return 'R$ 0,00'
      const number = parseFloat(value)
      const formatted = number.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
      return formatted
    }
  }
})

Vue.config.productionTip = false

// erros dos componentes → GlitchTip (o Sentry vem do CDN no public/index.html)
Vue.config.errorHandler = (err, vm, info) => {
  if (window.Sentry) window.Sentry.captureException(err, { extra: { info } })
  console.error(err)
}

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')
